/**
 * mentions: how a chart point of each widget maps back to the rows behind it,
 * for the conversations drill-down. Same filtering as the widget's loader.
 */
import { bucketStart } from '@/lib/analytics/buckets';
import { isoToMs } from '@/lib/analytics/dates';

import type { MentionRow } from '../engine/generator';
import { scoped } from '../query';
import type { DrillResolver, DrillResolvers } from './types';

/**
 * A bar of a categorical breakdown: every row in that category, across every
 * series — the prototype's `pivot().rowsAt`. No category → the whole scope.
 */
export function byCategory(
  scope: (query: Parameters<DrillResolver>[1]) => readonly MentionRow[],
  field: 'channel' | 'intent' | 'outlet',
): DrillResolver {
  return (ref, query) => {
    const rows = scope(query);
    const category = ref.category;
    if (!category) return rows;
    return rows.filter((row) => row[field] === category.value);
  };
}

const own = (query: Parameters<DrillResolver>[1]) => scoped(query).own;

export const mentionsDrillResolvers: DrillResolvers = {
  'mention-volume-over-time': (ref, query) => {
    const rows = scoped(query).own;
    const bucket = ref.bucket;
    if (!bucket) return rows;
    const start = isoToMs(bucket.start);
    return rows.filter((row) => bucketStart(row.day, bucket.unit) === start);
  },
  'mentions-by-platform': byCategory(own, 'channel'),
  'intent-based-mentions': byCategory(own, 'intent'),
};
